import { getFeatureFlagService } from '@arcual/lib-app-platform';

export enum FeatureFlagKeys {
  CURRENCY_CONFIGURATION = 'currency_configuration',
  DIGITAL_PORTFOLIO = 'digital_portfolio',
  ITEM_TRANSFER = 'item_transfer',
  LINK_IN_BIO = 'link_in_bio',
  MARK_AS_SOLD = 'mark_as_sold',
  NEW_DASHBOARD = 'new_dashboard',
  NOTIFICATIONS = 'notifications',
  PAYMENT_SETTINGS = 'payment_settings',
  SUBSCRIPTION = 'subscription',
  TEAM = 'team',
  VIEWING_ROOMS = 'viewing_rooms',
  VIDEO_ARTWORKS = 'video_artworks',
}

export const isFeatureEnabled = (key: FeatureFlagKeys): boolean => {
  return getFeatureFlagService().isFeatureEnabled(key);
};

export const isDigitalPortfolioEnabled = (): boolean => {
  return isFeatureEnabled(FeatureFlagKeys.DIGITAL_PORTFOLIO);
};

export const isItemTransferEnabled = (): boolean => {
  return isFeatureEnabled(FeatureFlagKeys.ITEM_TRANSFER);
};

export const isNewDashboardEnabled = (): boolean => {
  return isFeatureEnabled(FeatureFlagKeys.NEW_DASHBOARD);
};

export const isPaymentSettingsEnabled = (): boolean => {
  return isFeatureEnabled(FeatureFlagKeys.PAYMENT_SETTINGS);
};

export const isNotificationsEnabled = (): boolean => {
  return isFeatureEnabled(FeatureFlagKeys.NOTIFICATIONS);
};

export const isMarkAsSoldEnabled = (): boolean => {
  return isFeatureEnabled(FeatureFlagKeys.MARK_AS_SOLD);
};

export const isTeamEnabled = (): boolean => {
  return isFeatureEnabled(FeatureFlagKeys.TEAM);
};

export const isViewingRoomsEnabled = (): boolean => {
  return isFeatureEnabled(FeatureFlagKeys.VIEWING_ROOMS);
};

export const isLinkInBioEnabled = (): boolean => {
  return isFeatureEnabled(FeatureFlagKeys.LINK_IN_BIO);
};

export const isSubscriptionEnabled = (): boolean => {
  return isFeatureEnabled(FeatureFlagKeys.SUBSCRIPTION);
};

export const isCurrencyConfigurationEnabled = (): boolean => {
  return isFeatureEnabled(FeatureFlagKeys.CURRENCY_CONFIGURATION);
};

export const isVideoArtworkEnabled = (): boolean => {
  return isFeatureEnabled(FeatureFlagKeys.VIDEO_ARTWORKS);
};
